export const AW_LOCALIZATION_API_URL = process.env?.AWAPI_AWLOCALIZATIONSERVER_URL || '/awlocalization';
export const AW_LOCALIZATION_API_AGRAPH_URL =
  process.env?.AWAPI_AWLOCALIZATIONSERVER_AGRAPH_URL || '/api/wealth/shared-service/localization/v1';
export const AW_VARNISH_API_URL = process.env?.AWAPI_VARNISH_URL || '/varnish-plus';
